// extracted by mini-css-extract-plugin
module.exports =  {"root":"KJYoAThWu8lxjhgV7fJQ","header":"E_BiUhyjuOaoIhiQyzfc","actions":"wotAvzhm16UoyD89lvHi","footer":"yo9l4tU3MOlATWzHohkA"};